export enum ProcesoResultado {
  ERROR = "ERROR",
  WARNING = "WARNING",
  SUCCESS = "SUCCESS"
}

export default interface CoordinadorAdministrativoCalificacion {
  club: string;
  nombreClub: string;
  numeroEmpleado: number;
  coordinadorAdministrativo: string;
  metaDesercion: number;
  desercion: number;
  calificacionChecklist: number;
  var: number;
  calificacionDesercion: number;
  montoComision: number;
  mensaje: string;
  resultado: ProcesoResultado;
}
